import type { RouteRecordRaw } from 'vue-router';

export const productRoutes: Array<RouteRecordRaw> = [
  {
    path: '/product',
    name: 'product',
    redirect: '/product/list',
    component: () => import('pages/trade/admin/product/McProduct.vue'),
    meta: {
      title: 'Products',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'productList',
        component: () => import('pages/trade/admin/product/ProductList.vue'),
        meta: {
          title: 'Products List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'productDetail',
        component: () => import('pages/trade/admin/product/ProductDetail.vue'),
        meta: {
          title: 'Product Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'productNew',
        component: () => import('pages/trade/admin/product/ProductNew.vue'),
        meta: {
          title: 'New Product',
          requiresAuth: true,
        },
      },
      {
        path: 'view/:itemId?',
        name: 'productView',
        component: () => import('pages/trade/admin/product/ProductView.vue'),
        meta: {
          title: 'Product Details (View only)',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'productExplorer',
        component: () => import('pages/trade/admin/product/ProductExplorer.vue'),
        meta: {
          title: 'Products Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
